import { useEffect, useState } from "react";
import api, { downloadBlob, formatApiError } from "@/lib/api";
import { Loading, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Download, FileText } from "lucide-react";
import { toast } from "sonner";
import { formatINR, monthName } from "@/utils/format";

export default function EmployeePayslips() {
  const [list, setList] = useState(null);

  useEffect(() => { api.get("/portal/payslips").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (list === null) return <Loading />;

  const download = (p) => downloadBlob(`/portal/payslips/${p.id}/download`,
    `Payslip_${monthName(p.month)}_${p.year}.pdf`).catch((e) => toast.error(formatApiError(e)));

  return (
    <div data-testid="employee-payslips">
      <h1 className="font-display text-2xl font-semibold mb-1">Payslips</h1>
      <p className="text-sm text-muted-foreground mb-6">Your released payslips, newest first.</p>

      {list.length === 0 ? (
        <EmptyState icon={FileText} title="No payslips yet" description="Once your payroll is processed, payslips will show up here to download." testid="payslips-empty" />
      ) : (
        <div className="space-y-3">
          {list.map((p) => (
            <div key={p.id} className="bg-card border border-border rounded-md p-4 flex items-center justify-between" data-testid={`payslip-row-${p.month}-${p.year}`}>
              <div>
                <div className="font-medium">{p.month_name} {p.year}</div>
                <div className="text-xs text-muted-foreground tabular">FY {p.fy} · Net {formatINR(p.net)}</div>
              </div>
              <Button variant="outline" size="sm" className="gap-1.5" onClick={() => download(p)} data-testid={`download-payslip-${p.month}-${p.year}`}>
                <Download className="w-4 h-4" /> Download
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
